var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    transform: "rotate(-180 21 21)",
    fill: "#9A95CE",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7566 11.9983C16.0007 11.9983 16.2447 12.0882 16.4374 12.2809C16.8099 12.6534 16.8099 13.2699 16.4374 13.6424L9.32128 20.7586L16.4374 27.8747C16.8099 28.2472 16.8099 28.8637 16.4374 29.2362C16.0649 29.6088 15.4484 29.6088 15.0758 29.2362L7.27892 21.4393C6.90642 21.0668 6.90642 20.4503 7.27892 20.0778L15.0758 12.2809C15.2685 12.0882 15.5126 11.9983 15.7566 11.9983Z",
    fill: "#262832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17823 19.7959L29.7964 19.7959C30.323 19.7959 30.7598 20.2326 30.7598 20.7593C30.7598 21.2859 30.323 21.7227 29.7964 21.7227L8.17823 21.7227C7.65159 21.7227 7.21486 21.2859 7.21486 20.7593C7.21486 20.2326 7.65159 19.7959 8.17823 19.7959Z",
    fill: "#262832"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5852 29.5252C26.3411 29.5252 26.0971 29.4353 25.9044 29.2426C25.5319 28.8701 25.5319 28.2535 25.9044 27.881L33.0205 20.7649L25.9044 13.6488C25.5319 13.2763 25.5319 12.6597 25.9044 12.2872C26.2769 11.9147 26.8934 11.9147 27.2659 12.2872L35.0629 20.0841C35.4354 20.4566 35.4354 21.0732 35.0629 21.4457L27.2659 29.2426C27.0733 29.4353 26.8292 29.5252 26.5852 29.5252Z",
    fill: "#262832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1636 21.7275H12.5454C12.0188 21.7275 11.582 21.2908 11.582 20.7642C11.582 20.2375 12.0188 19.8008 12.5454 19.8008H34.1636C34.6902 19.8008 35.1269 20.2375 35.1269 20.7642C35.1269 21.2908 34.6902 21.7275 34.1636 21.7275Z",
    fill: "#262832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchange-icon.b68f43fea952aeb85281f96b99a3118c.svg";
export { ForwardRef as ReactComponent };